var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe-container"},[_c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":"https://fastgpt.cmclouds.com/chat/share?shareId=415a8vh5oq8nycqz4jjoybbj","border":"0","allow":"*"}})])
}]

export { render, staticRenderFns }